module.exports = __webpack_public_path__ + "static/Burst_4-da02ea05882da36cde486837c36fd643.jpg";